import * as R from 'ramda'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { Drawer } from '../../components/PopUp'
import { toggleDonationItemDrawer } from '../../redux/app/actions'

const StyleDonationList = styled.div`
  padding: 44px 16px 0;
`

const DonationListDrawer = ({ onCloseClickTracking, children, ...props }) => {
  const dispatch = useDispatch()
  const showDonationItemDrawer = useSelector(
    R.path(['appState', 'showDonationItemDrawer'])
  )

  const onCloseDrawer = () => {
    dispatch(toggleDonationItemDrawer())
    onCloseClickTracking && onCloseClickTracking()
  }
  return (
    <Drawer
      height='100%'
      show={showDonationItemDrawer}
      placement='bottom'
      showCloseBtn
      autoFocus
      onClose={onCloseDrawer}
    >
      <StyleDonationList>{children}</StyleDonationList>
    </Drawer>
  )
}

export default DonationListDrawer
